import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-10 max-w-xs text-center" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_3 = { class: "text-lg font-semibold leading-tight text-gray-900 mt-6 mb-2" }


import { BaseModal } from '@/lib/components/Modals';
import { BaseIcon } from '@/lib/components/Icon';
import IconGlyph from '@/lib/components/Icon/IconGlyph.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartFormComplete',
  props: {
  heading: {
    type: String,
    required: true
  },
  body: {
    type: String,
    required: true
  },
  isGlyph: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: 'check-glyph'
  },
  iconColor: {
    type: String,
    default: 'primary-500'
  },
  stroke: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), { "close-on-background-click": false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.isGlyph)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(IconGlyph, {
                name: __props.icon,
                color: __props.iconColor,
                size: "large"
              }, null, 8, ["name", "color"])
            ]))
          : (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 1,
              name: __props.icon,
              class: _normalizeClass('text-' + __props.iconColor),
              height: "64px",
              stroke: __props.stroke
            }, null, 8, ["name", "class", "stroke"])),
        _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.heading), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.body.split('\n'), (line) => {
          return (_openBlock(), _createElementBlock("p", {
            key: line,
            class: "text-gray-600"
          }, _toDisplayString(line), 1))
        }), 128)),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})